import { Extension } from "@tiptap/core"
import { NodeSelection, Plugin, PluginKey } from "@tiptap/pm/state"
import { Decoration, DecorationSet } from "@tiptap/pm/view"

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    nodeType: {
      setParentHighlight: (pos: number | null) => ReturnType
    }
  }
}

const nodeTypeKey = new PluginKey("nodeType")

export const NodeTypeExtension = Extension.create({
  name: "nodeType",

  addStorage() {
    return {
      parentHighlightPos: null as number | null,
    }
  },

  onCreate() {
    const { editor } = this
    if (!editor) return

    editor.registerPlugin(
      new Plugin({
        key: nodeTypeKey,
        props: {
          decorations: state => {
            const decorations: Decoration[] = []
            const { selection } = state
            const isNodeSelection = selection instanceof NodeSelection
            const parentHighlightPos = this.storage.parentHighlightPos

            state.doc.descendants((node, pos) => {
              const attrs: Record<string, string> = {
                "data-type": node.type.name,
              }

              if (isNodeSelection && pos === selection.from) {
                attrs["data-selected"] = "true"
              }

              if (parentHighlightPos === pos) {
                attrs["data-parent-highlighted"] = "true"
              }

              decorations.push(Decoration.node(pos, pos + node.nodeSize, attrs))
            })
            return DecorationSet.create(state.doc, decorations)
          },
        },
      }),
    )
  },

  addCommands() {
    return {
      setParentHighlight:
        (pos: number | null) =>
        ({ editor }) => {
          this.storage.parentHighlightPos = pos
          editor.view.updateState(editor.state)
          return true
        },
    }
  },
})
